@if (prop.type === 'boolean') {
    <div class="checkbox-wrapper">
        <mat-checkbox [formControl]="control">
            {{ 'property.' + prop.name|translate }}
            @if (prop.hint) {
                <mat-icon matTooltip="{{ prop.hint | translate }}" inline>info</mat-icon>
            }
        </mat-checkbox>
    </div>
} @else {
    <mat-form-field style="width: 100%">
        <mat-label>
            {{ 'property.' + prop.name|translate }}
            @if (prop.hint) {
                <mat-icon matTooltip="{{ prop.hint | translate }}">info</mat-icon>
            }
        </mat-label>
        @if (prop.type === 'text') {
            @if (prop.isMultiple) {
                <mat-chip-grid #chipGrid [formControl]="control">
                    @for (entry of getChipEntries(); track entry) {
                        <mat-chip-row (removed)="removeChipEntry(entry)">
                            {{ entry }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    }
                </mat-chip-grid>
                <input
                        placeholder="{{ 'property.' + prop.name + '.placeholder'|translate }}"
                        [matChipInputFor]="chipGrid"
                        (matChipInputTokenEnd)="addChipEntry($event)"
                        (blur)="handleBlur($event)"
                />
            } @else {
                <input matInput [formControl]="control">
            }
        } @else if (prop.type === 'textarea') {
            <textarea matInput [formControl]="control"></textarea>
        } @else if (prop.type === 'checkbox') {
            <mat-select [formControl]="control" multiple>
                @for (option of prop.values; track option) {
                    <mat-option [value]="option.value">
                        {{ 'property.' + prop.name + '.' + option.value | translate }}
                    </mat-option>
                }
            </mat-select>
        }
    </mat-form-field>
}